const ChemistrieVariantMapping = {
    sunClipLenses: {
        gradient: {
            Amber: {
                variantId: "45235605209249",
                productId: "8324839702689",
                handle: "gradient-amber-lens"
            },
            "Crimson Grey": {
                variantId: "45235605143713",
                productId: "8324839637153",
                handle: "gradient-crimson-grey-lens"
            },
            "Dark Brown": {
                variantId: "45235605110945",
                productId: "8324839604385",
                handle: "gradient-dark-brown-lens"
            },
            "Dark Grey": {
                variantId: "45235605078177",
                productId: "8324839571617",
                handle: "gradient-dark-grey-lens"
            },
            "Medium Brown": {
                variantId: "45235605045409",
                productId: "8324839538849",
                handle: "gradient-medium-brown-lens"
            },
            Rouge: {
                variantId: "45235605012641",
                productId: "8324839506081",
                handle: "gradient-rouge-lens"
            },
            "Violet Grey": {
                variantId: "45235604979873",
                productId: "8324839473313",
                handle: "gradient-violet-grey-lens"
            },
            "Violet Rose": {
                variantId: "45235604914337",
                productId: "8324839440545",
                handle: "gradient-violet-rose-lens"
            }
        },
        mirror: {
            Blue: {
                variantId: "45235606847649",
                productId: "8324840063137",
                handle: "mirror-blue-lens"
            },
            Caliente: {
                variantId: "45235606814881",
                productId: "8324839997601",
                handle: "mirror-caliente-lens"
            },
            Gold: {
                variantId: "45235606782113",
                productId: "8324839964833",
                handle: "mirror-gold-lens"
            },
            Green: {
                variantId: "45235606749345",
                productId: "8324839932065",
                handle: "mirror-green-lens"
            },
            Morado: {
                variantId: "45235605635233",
                productId: "8324839866529",
                handle: "mirror-morado-lens"
            },
            Orange: {
                variantId: "45235605602465",
                productId: "8324839833761",
                handle: "mirror-orange-lens"
            },
            Silver: {
                variantId: "45235605307553",
                productId: "8324839768225",
                handle: "mirror-silver-lens"
            },
            "Sky Blue": {
                variantId: "45235605242017",
                productId: "8324839735457",
                handle: "mirror-sky-blue-lens"
            }
        },
        solid: {
            Amber: {
                variantId: "45235609862305",
                productId: "8324840390817",
                handle: "solid-amber-lens"
            },
            Blue: {
                variantId: "45235609108641",
                productId: "8324840325281",
                handle: "solid-blue-lens"
            },
            Bronze: {
                variantId: "45235609075873",
                productId: "8324840292513",
                handle: "solid-bronze-lens"
            },
            Brown: {
                variantId: "45235609043105",
                productId: "8324840259745",
                handle: "solid-brown-lens"
            },
            G15: {
                variantId: "45235609010337",
                productId: "8324840226977",
                handle: "solid-g15-lens"
            },
            Grey: {
                variantId: "45235607503009",
                productId: "8324840128673",
                handle: "solid-grey-lens"
            },
            Rose: {
                variantId: "45235607535777",
                productId: "8324840194209",
                handle: "solid-rose-lens"
            },
            Yellow: {
                variantId: "45235607470241",
                productId: "8324840095905",
                handle: "solid-yellow-lens"
            }
        }
    },
    readerClipLenses: {
        "+0.50": {
            variantId: "45235610714273",
            productId: "8324840554657",
            handle: "reader-0-50-lens"
        },
        "+0.75": {
            variantId: "45235610747041",
            productId: "8324840587425",
            handle: "reader-0-75-lens"
        },
        "+1.00": {
            variantId: "45235610943649",
            productId: "8324840652961",
            handle: "reader-1-00-lens"
        },
        "+1.25": {
            variantId: "45235611173025",
            productId: "8324840718497",
            handle: "reader-1-25-lens"
        },
        "+1.50": {
            variantId: "45235611205793",
            productId: "8324840751265",
            handle: "reader-1-50-lens"
        },
        "+1.75": {
            variantId: "45235611435169",
            productId: "8324840816801",
            handle: "reader-1-75-lens"
        },
        "+2.00": {
            variantId: "45235611664545",
            productId: "8324840882337",
            handle: "reader-2-00-lens"
        },
        "+2.25": {
            variantId: "45235611697313",
            productId: "8324840915105",
            handle: "reader-2-25-lens"
        },
        "+2.50": {
            variantId: "45235611893921",
            productId: "8324840980641",
            handle: "reader-2-50-lens"
        }
    },
    blueLightClipLenses: {
        "0.00": {
            variantId: "45235611926689",
            productId: "8324841013409",
            handle: "blue-light-lens"
        },
        "+0.50": {
            variantId: "45235613794465",
            productId: "8324841078945",
            handle: "blue-light-0-50-lens"
        },
        "+0.75": {
            variantId: "45235613827233",
            productId: "8324841111713",
            handle: "blue-light-0-75-lens"
        },
        "+1.00": {
            variantId: "45235613860001",
            productId: "8324841144481",
            handle: "blue-light-1-00-lens"
        },
        "+1.25": {
            variantId: "45235613892769",
            productId: "8324841177249",
            handle: "blue-light-1-25-lens"
        },
        "+1.50": {
            variantId: "45235614711969",
            productId: "8324841242785",
            handle: "blue-light-1-50-lens"
        },
        "+1.75": {
            variantId: "45235614744737",
            productId: "8324841275553",
            handle: "blue-light-1-75-lens"
        },
        "+2.00": {
            variantId: "45235614777505",
            productId: "8324841308321",
            handle: "blue-light-2-00-lens"
        }
    },
    therapeuticClipLenses: {
        "FL-41": {
            Light: {
                variantId: "45235615858849",
                productId: "8324841439393",
                handle: "fl-41-light-lens"
            },
            Medium: {
                variantId: "45235616874657",
                productId: "8324841504929",
                handle: "fl-41-medium-lens"
            }
        },
        Avulux: {
            Standard: {
                variantId: "45235615793313",
                productId: "8324841373857",
                handle: "avulux-light-lens"
            }
        }
    },
    otherClipLenses: {
        "3D": {
            variantId: "45235616940193",
            productId: "8324841570465",
            handle: "3d-lens"
        },
        Driving: {
            variantId: "45235616907425",
            productId: "8324841537697",
            handle: "night-driving-lens"
        }
    },
    bridgeHardware: {
        Gold: {
            variantId: "45235604193441",
            productId: "8324838817953",
            handle: "gold-bridge"
        },
        Silver: {
            variantId: "45235604226209",
            productId: "8324838850721",
            handle: "silver-bridge"
        },
        Bronze: {
            variantId: "45235604291745",
            productId: "8324838916257",
            handle: "bronze-bridge"
        },
        Gunmetal: {
            variantId: "45235604258977",
            productId: "8324838883489",
            handle: "gunmetal-bridge"
        },
        "Matte Black": {
            variantId: "45235604127905",
            productId: "8324838752417",
            handle: "matte-black-bridge"
        }
    },
    magnetHardware: {
        Gold: {
            variantId: "45235604062369",
            productId: "8324838686881",
            handle: "gold-magnets"
        },
        Silver: {
            variantId: "45235604095137",
            productId: "8324838719649",
            handle: "silver-magnets"
        },
        Gunmetal: {
            variantId: "45235604029601",
            productId: "8324838654113",
            handle: "gunmetal-magnets"
        }
    },
    crystalAccents: {
        Amethyst: {
            variantId: "45235604455585",
            productId: "8324839080097",
            handle: "amethyst-crystals"
        },
        Aquamarine: {
            variantId: "45235604488353",
            productId: "8324839112865",
            handle: "aquamarine-crystals"
        },
        Cobalt: {
            variantId: "45235604521121",
            productId: "8324839145633",
            handle: "cobalt-crystals"
        },
        Diamond: {
            variantId: "45235604390049",
            productId: "8324839014561",
            handle: "diamond-crystals"
        },
        Emerald: {
            variantId: "45235604422817",
            productId: "8324839047329",
            handle: "emerald-crystals"
        },
        Fireopal: {
            variantId: "45235604586657",
            productId: "8324839211169",
            handle: "fireopal-crystals"
        },
        Gold: {
            variantId: "45235604553889",
            productId: "8324839178401",
            handle: "gold-crystals"
        },
        Hematite: {
            variantId: "45235604750497",
            productId: "8324839276705",
            handle: "hematite-crystals"
        },
        Hyacinth: {
            variantId: "45235604783265",
            productId: "8324839309473",
            handle: "hyacinth-crystals"
        },
        Olivine: {
            variantId: "45235604816033",
            productId: "8324839342241",
            handle: "olivine-crystals"
        },
        Rose: {
            variantId: "45235604848801",
            productId: "8324839375009",
            handle: "rose-crystals"
        },
        Topaz: {
            variantId: "45235604881569",
            productId: "8324839407777",
            handle: "topaz-crystals"
        }
    },
    getSunLensVariantId(category, color) {
        try {
            const lens = this.sunClipLenses[category]?.[color];
            return lens?.variantId || null;
        } catch (error) {
            console.error(`Error getting Sun lens variant ID: ${category}/${color}`, error);
            return null;
        }
    },
    getReaderLensVariantId(magnification) {
        try {
            return this.readerClipLenses[magnification]?.variantId || null;
        } catch (error) {
            console.error(`Error getting Reader lens variant ID: ${magnification}`, error);
            return null;
        }
    },
    getBlueLightLensVariantId(magnification) {
        try {
            return this.blueLightClipLenses[magnification]?.variantId || null;
        } catch (error) {
            console.error(`Error getting Blue Light lens variant ID: ${magnification}`, error);
            return null;
        }
    },
    getTherapeuticLensVariantId(type, intensity) {
        try {
            return this.therapeuticClipLenses[type]?.[intensity]?.variantId || null;
        } catch (error) {
            console.error(`Error getting Therapeutic lens variant ID: ${type}/${intensity}`, error);
            return null;
        }
    },
    getOtherLensVariantId(type) {
        try {
            return this.otherClipLenses[type]?.variantId || null;
        } catch (error) {
            console.error(`Error getting other lens variant ID: ${type}`, error);
            return null;
        }
    },
    getBridgeVariantId(finish) {
        try {
            return this.bridgeHardware[finish]?.variantId || null;
        } catch (error) {
            console.error(`Error getting bridge variant ID: ${finish}`, error);
            return null;
        }
    },
    getMagnetVariantId(finish) {
        try {
            return this.magnetHardware[finish]?.variantId || null;
        } catch (error) {
            console.error(`Error getting magnet variant ID: ${finish}`, error);
            return null;
        }
    },
    getCrystalVariantId(type) {
        try {
            return this.crystalAccents[type]?.variantId || null;
        } catch (error) {
            console.error(`Error getting crystal variant ID: ${type}`, error);
            return null;
        }
    },
    findProduct(searchTerm) {
        const searchLower = searchTerm.toLowerCase();
        const categories = [ {
            name: "sunClipLenses",
            data: this.sunClipLenses
        }, {
            name: "readerClipLenses",
            data: this.readerClipLenses
        }, {
            name: "blueLightClipLenses",
            data: this.blueLightClipLenses
        }, {
            name: "therapeuticClipLenses",
            data: this.therapeuticClipLenses
        }, {
            name: "otherClipLenses",
            data: this.otherClipLenses
        }, {
            name: "bridgeHardware",
            data: this.bridgeHardware
        }, {
            name: "magnetHardware",
            data: this.magnetHardware
        }, {
            name: "crystalAccents",
            data: this.crystalAccents
        } ];
        for (const category of categories) {
            const result = this._searchInCategory(category.data, searchLower);
            if (result) {
                return {
                    ...result,
                    category: category.name
                };
            }
        }
        return null;
    },
    _searchInCategory(categoryData, searchTerm) {
        for (const key in categoryData) {
            const item = categoryData[key];
            if (typeof item === "object" && !item.variantId) {
                const nested = this._searchInCategory(item, searchTerm);
                if (nested) return nested;
            } else if (item.variantId) {
                if (item.handle === searchTerm || item.variantId === searchTerm || item.productId === searchTerm) {
                    return item;
                }
            }
        }
        return null;
    }
};

window.ChemistrieVariantMapping = ChemistrieVariantMapping;